import RangeInputs from './RangeInputs'

const CowAgeContentBlock = props => {
	const { handleDayChange, cowAge, availableAgeValues } = props
	return (
		<RangeInputs
			startValue={cowAge?.startOf}
			endValue={cowAge?.endOf}
			availableStart={availableAgeValues?.startOf}
			availableEnd={availableAgeValues?.endOf}
			fallbackPlaceholder='Год'
			onStartChange={e => handleDayChange(e, 'cowAge', 'startOf')}
			onEndChange={e => handleDayChange(e, 'cowAge', 'endOf')}
		/>
	)
}

export default CowAgeContentBlock
